export default function parseMediaType(filename) {
  if (filename.match(/\.mp3$/)) {
    return "audio/mp3";
  }
  if (filename.match(/webm$/)) {
    return "video/webm";
  }
  if (filename.match(/\.mpd$/)) {
    return "application/dash+xml";
  }
  if (filename.match(/\.m3u8$/)) {
    return "application/x-mpegURL";
  }
  if (filename.match(/\.mp4$/)) {
    return "video/mp4";
  }

  throw new Error(`Can't parse media type ${filename}`);
}
